import './Header.less';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu } from 'antd';
import Avatar from 'react-avatar';
import classnames from 'classnames';
import logo from '../assets/images/logo-new.svg';
import Confirm from './common/Confirm.jsx';

const CloseIcon = ({ className }) => {
    return (
        <div className={classnames(className, 'burger burger-squeeze')}>
            <div className="burger-lines"></div>
        </div>
    );
};

CloseIcon.propTypes = {
    className: PropTypes.string,
};

const Header = ({ logout, routers, userFirstName, userLastName }) => {
    const [isActive, setIsActive] = useState(false);
    const [visibleExit, toggleVisibleExit] = useState(false);
    const toggleActive = (e) => {
        setIsActive(Boolean(e.length));
    };

    useEffect(() => {
        document.body.classList = isActive ? 'overflow-hidden-xs' : '';
    }, [isActive]);

    const onToggleLogout = () => {
        toggleVisibleExit(!visibleExit);
    };

    const headerMenuItems = routers.map((route) => ({
        key: route.name,
        label: (
            <NavLink className={({ isActive }) => (isActive ? 'menu-item-selected' : '')} to={route.path}>
                {route.name}
            </NavLink>
        ),
    }));

    const items = [
        ...headerMenuItems,
        {
            label: (
                <Avatar
                    name={userFirstName + ' ' + userLastName}
                    size="40"
                    round={true}
                    color={Avatar.getRandomColor('#000000', ['#2BB01F', '#DB2828', '#EDAF10', '#1C63ED'])}
                />
            ),
            key: 'user-menu',
            className: 'menu-item-logout',
            onClick: onToggleLogout,
        },
    ];

    return (
        <>
            <Confirm
                title="Exit"
                message="You are going to exit from my Existek"
                okText="Exit"
                onConfirm={logout}
                isVisibleConfirm={visibleExit}
                cancelConfirm={onToggleLogout}
            />
            <header className={classnames('main-header', { active: isActive })}>
                <NavLink to="/dashboard" className="header-logo">
                    <img className="img-responsive" src={logo} alt="logo" />
                </NavLink>
                <div className="header">
                    <Menu
                        theme="dark"
                        mode="horizontal"
                        onOpenChange={toggleActive}
                        overflowedIndicator={
                            <CloseIcon className={classnames('header__hamburger', { open: isActive })} />
                        }
                        triggerSubMenuAction="click"
                        items={items}
                    ></Menu>
                </div>
            </header>
        </>
    );
};

Header.propTypes = {
    logout: PropTypes.func,
    routers: PropTypes.array,
    userFirstName: PropTypes.string,
    userLastName: PropTypes.string,
};
export default Header;
